        const StudentTableHeader = ["#",  "Company Name","Education", "Job Category","Experience","Action"];
        const AdminTableHeader=["#","Category","Company Name","Email"];
        const AdminTable=["#","Category","Name","Email","Action"];
        export {StudentTableHeader,AdminTableHeader,AdminTable}